import { loadingSpinner } from '~/vue/plugins/vueLoadingSpinner';

/**
 * The full-page loading overlay, for code that runs outside a vue component
 * (components have `this.$loadingSpinner`).
 *
 * The overlay is reference counted, and `hide` is deferred by a tick so that a
 * `show` following straight after a `hide` keeps it up instead of flickering.
 */
export function showDimmer () {
    loadingSpinner.show();
}

export function hideDimmer () {
    setTimeout(() => loadingSpinner.hide(), 10);
}
